import React from 'react';
import { PasswordStrength, getPasswordStrengthLabel } from '../utils/password-validation';

interface PasswordStrengthIndicatorProps {
  strength: PasswordStrength;
  color: string;
  showLabel?: boolean;
  className?: string;
}

export function PasswordStrengthIndicator({
  strength,
  color,
  showLabel = true,
  className = ''
}: PasswordStrengthIndicatorProps) {
  // Skip rendering for empty passwords
  if (strength === PasswordStrength.None) {
    return null;
  }

  return (
    <div className={`flex items-center gap-2 mt-1.5 ${className}`}>
      <div className="flex-1 h-1.5 rounded-full bg-muted overflow-hidden">
        <div 
          className="h-full rounded-full transition-all duration-300 ease-in-out"
          style={{ 
            width: `${Math.max(5, (strength / 4) * 100)}%`, 
            backgroundColor: color 
          }}
        />
      </div>
      {showLabel && (
        <span 
          className="text-xs"
          style={{ color }}
        >
          {getPasswordStrengthLabel(strength)}
        </span>
      )}
    </div>
  );
}
